/**
 * Code by Mathieu VANBESELAERE for ->
 * @copyright Copyright (c) Agence ink
 */

// ? This script gathers all the code required to make the party system to work, including:
// * A) Copy the public presentation mode link to the user's clipboard
// * B) Send a vote request to the controller via AJAX
// * C) Seach for a dance with AJAX
// * D) Autorefresh the page after a given time
// * E) Hide side content on presentation mode
// * F) Block any second click on a .vote-feature-cta
// * G) Open and close played dances section on mobile

import gsap from "gsap";

export const party = () => {
    // * = (AJAX CONTROLLER) => Function to get the CSRF token from Craft
    const getSessionInfo = async function () {
        try {
            const response = await fetch("/actions/users/session-info", {
                headers: {
                    Accept: "application/json",
                },
            });
            const data = await response.json();
            return data;
        } catch (error) {
            // Handle any errors here
            console.error("An error occurred fetching the CSRF token.");
        }
    };

    let partyComponent = document.querySelector(".party-component");
    if (partyComponent) {
        // * A) Copy the public presentation mode link to the user's clipboard
        let presentationModeLink = document.querySelector("[data-presentation-link]");
        if (presentationModeLink) {
            let button = document.querySelector("[data-presentation-button]");
            let buttonFormerContent = button.textContent;
            button.addEventListener("click", () => {
                button.style.width = button.offsetWidth + "px"; // Keep the same width

                // Add to clipboard
                navigator.clipboard.writeText(presentationModeLink.getAttribute("href")).then(
                    () => {
                        button.textContent = "Lien copié !";
                    },
                    () => {
                        button.textContent = "Erreur...";
                    }
                );

                setTimeout(() => (button.textContent = buttonFormerContent), 2000); // Put the button text back
            });
        }

        // * B) Send a vote request to the controller via AJAX
        // ? These functions are out of the B) scope because it is also called by C) after a search

        // == vote()
        // -> 1) On click on a vote button, remove dance data and add the .voting class to prevent further votings
        // -> 2) On successful AJAX response, add or remove the .down class
        // -> 3) Finally, toggle the .voting class
        async function vote(e) {
            e.preventDefault();
            let cta = e.currentTarget;

            // Only proceed if the vote action is not already taking place
            if (cta.hasAttribute("data-vote-cta") && !cta.classList.contains("voting")) {
                let partyId = cta.getAttribute("data-party");
                let danceId = cta.getAttribute("data-vote-cta");

                let ready = () => {
                    // Put the data-vote-cta attribute back
                    cta.setAttribute("data-vote-cta", danceId);
                    cta.classList.remove("voting");
                };

                // We remove the dance id from the cta so if cannot be processed if another click is ever made
                // The .voting class is supposed to prevent further clicks, but one can always tweak an HTML source...
                cta.removeAttribute("data-vote-cta");
                cta.classList.add("voting");

                // AJAX call for a vote with the given elements
                let data = {
                    "party-id": partyId,
                    "dance-id": danceId,
                };

                try {
                    const session = await getSessionInfo();
                    const response = await fetch("/actions/_winslow/party/vote", {
                        method: "POST",
                        headers: {
                            Accept: "application/json",
                            "Content-Type": "application/json",
                            "X-CSRF-Token": session.csrfTokenValue,
                            "X-Requested-With": "XMLHttpRequest",
                        },
                        body: JSON.stringify(data),
                    });

                    const result = await response.json(); // Cue Bruno Mars: "STOP! Waittaminute"

                    if (response.status == 200) {
                        // Add or remove the .down class according to the taken action
                        // TODO: check wether we double check the vote action

                        if (!cta.classList.contains("down")) {
                            console.log("VOTED!");
                            cta.classList.add("down");
                            // cta.innerHTML = "&times; Retirer vote &times;";
                            refreshCounter(cta);
                        } else {
                            console.log("UN-VOTED!");
                            cta.classList.remove("down");
                            // cta.textContent = "Voter";
                            refreshCounter(cta);
                        }
                    } else {
                        cta.textContent = "error, tap to try again";
                        // TODO: Create a counter each time we fail. If > 2, force resfresh the user page?
                    }

                    ready();
                } catch (error) {
                    console.log("An error occurred while attempting to vote.");
                    cta.textContent = "error, tap to try again";
                    console.log(error);
                    ready();
                }
            }
        }

        // == refreshCounter()
        // Calls a tiny ajax to refresh the number of votes for a given playlist item in a party
        async function refreshCounter(cta) {
            let counter = cta.parentElement.parentElement.querySelector("[data-vote-count]");
            if (counter) {
                let url = "/ajax/refresh-counter?mb=" + counter.getAttribute("data-vote-count");

                try {
                    const response = await fetch(url);
                    if (!response.ok) {
                        throw new Error("HTTP error! Status: " + response.status);
                    }
                    const htmlContent = await response.text();
                    counter.innerHTML = htmlContent;
                } catch (error) {
                    console.error("An error occurred:", error);
                    counter.innerHTML = "error";
                }
            }
        }

        let voteCtas = document.querySelectorAll("[data-vote-cta]");
        if (voteCtas.length > 0) {
            voteCtas.forEach((currentCta) => currentCta.addEventListener("click", vote));
        }

        // * C) Seach for a dance with AJAX
        let searchField = partyComponent.querySelector("[data-party-search]");
        if (searchField) {
            // Variables
            let loadingIcon = partyComponent.querySelector("[data-loading]").innerHTML;
            let resultContainer = partyComponent.querySelector("[data-result]");
            let partyId = searchField.getAttribute("data-party-search");
            let resetCta = partyComponent.querySelector("[data-reset-search]");

            resetCta.addEventListener("click", (e) => {
                e.preventDefault();
                e.currentTarget.style.display = "none";
                resultContainer.innerHTML = "";
                searchField.scrollIntoView({ behavior: "smooth", block: "center" });
                searchField.value = "";
                searchField.focus();
            });

            // The search function
            async function search(data) {
                let url = "/ajax/dance-search?party=" + partyId + "&search=" + data;

                try {
                    const response = await fetch(url);
                    if (!response.ok) {
                        throw new Error("HTTP error! Status: " + response.status);
                    }
                    const htmlContent = await response.text();
                    resultContainer.innerHTML = htmlContent;

                    // Add listeners on the potentially existing vote ctas
                    let searchVoteCtas = resultContainer.querySelectorAll("[data-vote-cta]");
                    if (searchVoteCtas.length > 0) {
                        searchVoteCtas.forEach((currentCta) => currentCta.addEventListener("click", vote));
                    }
                } catch (error) {
                    console.error("An error occurred:", error);
                    resultContainer.innerHTML = "<p class='text-color-white'>An error occurred while fetching the dances data.</p>";
                }
            }

            // Listening for a search
            let call;
            searchField.addEventListener("input", (e) => {
                clearTimeout(call);
                let data = e.currentTarget.value;

                if (data.length >= 3) {
                    resultContainer.innerHTML = loadingIcon;
                    call = setTimeout(() => {
                        search(data);
                    }, 666);
                    resetCta.style.display = "flex";
                } else if (data.length === 0) {
                    resultContainer.innerHTML = "";
                    resetCta.style.display = "none";
                } else {
                    call = setTimeout(() => {
                        resultContainer.innerHTML = "";
                    }, 666);
                }
            });
        }

        // * D) Autorefresh the page after a given time
        let autorefresh = (element) => {
            let refreshDelay = Number.parseInt(element.getAttribute("data-autorefresh"));
            if (Number.isInteger(refreshDelay)) {
                // Countdown in console
                let countdown = refreshDelay;
                console.log("Autorefresh is enabled! (" + refreshDelay + "s)");
                setInterval(() => {
                    countdown--;
                    console.log("Autorefresh in " + countdown + "..");
                }, 1000);
                // Refresh
                setTimeout(() => {
                    location.reload();
                }, refreshDelay * 1000);

                let bar = document.querySelector(".refresh-bar div");
                if (bar) {
                    gsap.to(bar, {
                        x: 0,
                        backgroundColor: "#f48421",
                        duration: refreshDelay,
                        ease: "none",
                    });
                }
            }
        };

        // Autorefresh manual activation
        let autorefreshCta = document.querySelector(".autorefresh-icon");
        if (autorefreshCta) {
            let activated = localStorage.getItem("winslow-autorefresh") || false;

            // Animation
            let rotate = gsap.timeline({ repeat: -1, ease: "linear" });
            rotate.to(autorefreshCta, { rotation: 360, duration: 2, ease: "linear" });
            rotate.pause();

            let enable = () => {
                localStorage.setItem("winslow-autorefresh", true);
                gsap.set(autorefreshCta, { autoAlpha: 1 });
                rotate.play();
                autorefresh(autorefreshCta);
                activated = true;
            };

            if (activated) {
                enable();
            }

            autorefreshCta.addEventListener("click", () => {
                if (activated) {
                    // Unset local variable
                    localStorage.removeItem("winslow-autorefresh");
                    location.reload();
                } else {
                    enable();
                }
            });
        }

        // * D-bis) Refresh on click
        let refreshCtas = document.querySelectorAll("[data-refresh]");
        if (refreshCtas.length > 0) {
            refreshCtas.forEach((cta) => {
                cta.addEventListener("click", () => {
                    location.reload();
                });
            });
        }

        // * E) Hide side content on presentation mode
        let presentationMode = document.querySelector("[data-presentation]");
        if (presentationMode) {
            let hideAbleContents = document.querySelectorAll(".navbar, .section_footer-partners, footer, .section_credits");
            if (hideAbleContents.length > 0) {
                hideAbleContents.forEach((current) => {
                    current.style.display = "none";
                });
                document.querySelector("body").style.overflow = "hidden";
            }

            // Call the autorefresh, as this part is only called on presentation mode
            autorefresh(presentationMode);
        }

        // * F) Block any second click on a .vote-feature-cta
        let lockableCtas = document.querySelectorAll(".vote-feature-cta");
        if (lockableCtas.length > 0) {
            for (let currentCta of lockableCtas) {
                currentCta.addEventListener("click", () => {
                    setTimeout(() => {
                        currentCta.textContent = "...";
                        currentCta.style.webkitFilter = "invert(1)";
                        currentCta.style.opacity = 0.33;
                        currentCta.style.cursor = "not-allowed";
                        currentCta.style.pointerEvents = "none";
                    }, 100); // Safacancer
                });
            }
        }

        // * G) Open and close played dances section on mobile
        let alreadyPlayedSections = document.querySelector(".already-played");
        if (alreadyPlayedSections) {
            let collapsed = false;
            let mainCta = document.querySelector("[data-played-main-cta]");
            let closeCta = document.querySelector("[data-played-close-cta]");
            let revealText = mainCta.textContent;
            let hideText = closeCta.textContent;

            let hide = () => {
                alreadyPlayedSections.style.height = "1px";
                mainCta.textContent = revealText;
                collapsed = false;
                alreadyPlayedSections.parentElement.scrollIntoView({ behavior: "smooth" });
            };

            let reveal = () => {
                alreadyPlayedSections.style.height = "auto";
                mainCta.textContent = hideText;
                collapsed = true;
            };

            mainCta.addEventListener("click", (e) => {
                e.preventDefault();
                e.stopPropagation();

                if (!collapsed) {
                    reveal();
                } else {
                    hide();
                }
            });

            closeCta.addEventListener("click", (e) => {
                e.preventDefault();
                e.stopPropagation();
                hide();
            });
        }
    }

    return;
};
